import _ from 'lodash';

export default label => {
    const value = label.value || label;

    return label.text || _.startCase(value);
};
